module.exports = __webpack_public_path__ + "img/3.fe28b0da.png";